module.exports = __webpack_public_path__ + "static/contract-package-1-7912f518ab1da707554d6fe2e6cf1592.pdf";